import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconEditOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="M21.05 22.52 21.03 9.259H22.5v13.29A1.45 1.45 0 0 1 21.05 24H0V2.95c0-.8.65-1.45 1.45-1.45h13.276v1.48H1.45l.027 19.54zM9.478 13.465l1.5-1.5 1.06 1.06-1.499 1.5zM22.94 0 24 1.061l-1.195 1.194-.75.75-1.495 1.496-.754.754-6.678 6.681-1.06-1.061 6.68-6.682.75-.75 1.499-1.5.75-.75z" /></svg>
);
